<div [hidden]="allRestaurants.length == 1 || dataLoading">
    <!-- <p class="orange-color text-right mb-2 font-14" *ngIf="currentRest?.attendancefeature">
      {{"auth.Clock-In" | translate}}: <span class="fontSemiBold">{{currentRest?.lastClockIn | date:'d MMM, y - h:mm a'}}</span>
    </p> -->
    <div class="page-filters mb-0" *ngIf="actionsPermissions?.canShowBranch">
        <div class="sort-item restaurant-sort-item">
            <label *ngIf="!hideLabel">{{ 'forms.Select Restaurant' | translate }}:</label>
            <select class="form-control"
                (change)="getSelectedRestaurant(restaurantId)"
                [(ngModel)]="restaurantId">
                <option *ngFor="let restaurant of allRestaurants" [value]="restaurant.id">{{restaurant.name}}
                </option>
            </select>
        </div>
    </div>
</div>
